import React, {useContext} from 'react';
import {WooContext} from "../WooContext";
import Button from "../Elements/Button";
import {ButtonStyles} from "../Elements/consts";
import {resetOffset} from "../Functions/Helpers";

function HireOrSaleOptions() {
    const {hireOrSaleState, pagedState} = useContext(WooContext);
    const [hireOrSale,setHireOrSale] = hireOrSaleState;
    const [,setPaged] = pagedState;
    return(
        <ul className="filter-options filter-options-product-type">
            <li className={hireOrSale === 'SALE' ? 'active': ''}>
                <Button style={ButtonStyles.outlineSecondary} onClick={(e) => {
                    e.preventDefault();
                    setHireOrSale(hireOrSale === 'SALE' ? '' : 'SALE');
                    resetOffset(setPaged);
                }}>
                        <span>Buy</span>
                </Button>
            </li>
            <li className={hireOrSale === 'HIRE' ? 'active': ''}>
                <Button style={ButtonStyles.outlineSecondary} onClick={(e) => {
                    e.preventDefault();
                    setHireOrSale(hireOrSale === 'HIRE' ? '' : 'HIRE');
                    resetOffset(setPaged);
                }}>
                        <span>Hire</span>
                </Button>
            </li>
        </ul>
    )
}

export default HireOrSaleOptions;